import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useMemoizedFn, useSafeState, useUnmountedRef, useUpdateEffect } from 'ahooks';
import { useEffect, useRef } from 'react';
import { generateUuid } from "../function/utils";
export var useFinalRequest = function useFinalRequest(request) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$ready = options.ready,
      ready = _options$ready === void 0 ? true : _options$ready,
      _options$manual = options.manual,
      manual = _options$manual === void 0 ? false : _options$manual,
      _options$defaultParam = options.defaultParams,
      defaultParams = _options$defaultParam === void 0 ? [] : _options$defaultParam,
      initialData = options.initialData,
      _options$refreshDeps = options.refreshDeps,
      refreshDeps = _options$refreshDeps === void 0 ? [] : _options$refreshDeps,
      onBefore = options.onBefore,
      onSuccess = options.onSuccess;
  var lastRequest = useRef();
  var isUnmounted = useUnmountedRef();

  var _useSafeState = useSafeState(false),
      _useSafeState2 = _slicedToArray(_useSafeState, 2),
      loading = _useSafeState2[0],
      setLoading = _useSafeState2[1];

  var _useSafeState3 = useSafeState(initialData),
      _useSafeState4 = _slicedToArray(_useSafeState3, 2),
      data = _useSafeState4[0],
      mutate = _useSafeState4[1];

  var runAsync = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        params,
        ok,
        requestId,
        response,
        _data,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            params = args.length ? args : defaultParams;

            if (ready) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return");

          case 4:
            if (!onBefore) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return onBefore(params);

          case 7:
            ok = _context.sent;

            if (!(ok === false)) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return");

          case 10:
            requestId = generateUuid();
            lastRequest.current = {
              id: requestId,
              params: params
            };
            setLoading(true);
            _context.next = 15;
            return request.apply(void 0, _toConsumableArray(params));

          case 15:
            response = _context.sent;

            if (!isUnmounted.current) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return");

          case 18:
            if (!(requestId === lastRequest.current.id)) {
              _context.next = 25;
              break;
            }

            if (!onSuccess) {
              _context.next = 24;
              break;
            }

            _context.next = 22;
            return onSuccess(response, params);

          case 22:
            _data = _context.sent;
            mutate(_data);

          case 24:
            setLoading(false);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })));
  var run = useMemoizedFn(function () {
    runAsync.apply(void 0, arguments);
  });
  var refreshAsync = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _lastRequest$current$, _lastRequest$current;

    var params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = (_lastRequest$current$ = (_lastRequest$current = lastRequest.current) === null || _lastRequest$current === void 0 ? void 0 : _lastRequest$current.params) !== null && _lastRequest$current$ !== void 0 ? _lastRequest$current$ : [];
            _context2.next = 3;
            return runAsync.apply(void 0, _toConsumableArray(params));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })));
  var refresh = useMemoizedFn(function () {
    refreshAsync();
  });
  useUpdateEffect(function () {
    if (!lastRequest.current) {
      return;
    }

    refresh();
  }, refreshDeps);
  useEffect(function () {
    if (!manual && ready) {
      refresh();
    }
  }, [ready]);
  return {
    loading: loading,
    data: data,
    mutate: mutate,
    run: run,
    runAsync: runAsync,
    refresh: refresh,
    refreshAsync: refreshAsync
  };
};